import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../shared/services/app.service';

@Component({
    selector: 'app-speedtest',
    templateUrl: './speedtest.component.html',
    styleUrls: ['./speedtest.component.scss'],
    standalone: false
})
export class SpeedTestComponent implements OnInit {

  constructor() {
   
   }

  ngOnInit() {
  
  }
  
}
